<template>
    <van-popup v-model="showPopup" position="bottom" round>
        <div class="popup-box">
            <div class="popup-title">代用户兑换领取优惠券</div>
            <div class="popup-content">
                <div class="user-no">用户编号: {{ this.userNo }}</div>
                <div class="receive-title">优惠券兑换码:</div>
                <div class="input-box">
                    <van-field v-model="code" placeholder="请输入优惠券兑换码" />
                </div>
                <div class="use-num">用户可用券：{{ couponList.length }}张</div>
                <div class="coupon-list" v-if="couponList.length">
                    <div class="coupon-item" v-for="(item, index) in couponList" :key="index"
                        :class="index === 0 ? '' : 'van-hairline--top'">
                        <div class="title">{{ item.userMemberName ? names[item.couponType] : item.couponName }}</div>
                        <div class="info">{{ onCouponRuleName(item) }}</div>
                        <div class="info">有效期至：{{ timeFormat(item.validEndDate) }}</div>
                    </div>
                </div>
                <van-empty description="暂无优惠券，请兑换" v-else />
            </div>
            <div class="popup-bottom">
                <van-button type="info" block round color="#0082EF" @click="onReceive" :loading="loading">
                    确认兑换并领取
                </van-button>
            </div>
        </div>
    </van-popup>
</template>
<script>
import request from '@/utils/request'
import { timeFormat } from '@/utils/baseFormat'
import qs from 'qs';

export default {
    name: "receiveCoupon",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        userNo: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            code: '',
            couponList: [],
            loading: false,
            names: ['购药满减券', '购药折扣券', '购药免费券', '协议问诊抵扣券', '免费挂号券', '购药满收券']
        }
    },
    methods: {
        timeFormat,
        async onReceive() {
            this.loading = true
            if (!this.code) {
                this.$toast('请输入优惠券兑换码');
                this.loading = false
                return
            }
            const toast = this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            try {
                const { code } = await request({
                    method: 'post',
                    url: `/order-service/app/coupon/receive/${this.userNo}`,
                    data: qs.stringify({
                        couponCode: this.onCouponTransform(this.code),
                        userNo: this.userNo,
                        receiveType: 2,
                        status: 0
                    }),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                if (code === 0) {
                    this.code = ''
                    this.$toast('兑换领取成功');
                    this.getCouponList()
                }
            } finally {
                this.loading = false
                toast.clear();
            }
        },
        onCouponTransform(str) {
            let reg = new RegExp('[?&]code=([^&]*)(&|$)');
            let res = str.match(reg);
            return res && res[1] || str;
        },
        onCouponRuleName(row) { // 优惠规则名称
            return {
                0: `单次问诊满${row.full || 0}元抵扣${row.free || 0}元`,
                1: `单次问诊${row.discount || 0}折优惠`,
                2: `单次问诊金额全额抵扣`,
                3: `协议抵扣券`,
                4: `单次挂号金额全额抵扣`,
                5: `订单金额满${row.full || 0}元收${row.free || 0}元`
            }[row.couponType]
        },
        async getCouponList() {
            try {
                const { data } = await request({
                    method: 'post',
                    url: '/order-service/app/coupon/list',
                    data: qs.stringify({
                        status: 0,
                        pageNum: 1,
                        pageSize: 999,
                        userNo: this.userNo
                    })
                })
                this.couponList = data.list || []
            } catch (error) {
                console.log(error)
            }
        }
    },
    computed: {
        showPopup: {
            get() {
                return this.show
            },
            set(value) {
                this.$emit("update:show", value);
            }
        },
    },
    watch: {
        showPopup: {
            handler(val) {
                if (val) {
                    this.code = ''
                    this.getCouponList()
                }
            },
            immediate: true
        }
    },
    created() { },
    activated() { }
}
</script>
<style lang='scss' scoped>
.popup-box {
    height: 75vh;
    display: flex;
    flex-direction: column;

    .popup-title {
        padding: 15px;
        color: #333;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }

    .popup-content {
        padding: 15px;
        flex: 1;
        overflow-y: auto;

        .user-no {
            color: #333;
            font-size: 18px;
            position: relative;
            padding-left: 11px;
            font-weight: bold;

            &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 2px;
                transform: translateY(-50%);
                width: 2px;
                height: 12px;
                background: #0082EF;
                border-radius: 6px;
            }
        }

        .receive-title {
            margin-top: 20px;
            color: #333;
            font-size: 18px;
        }

        .input-box {
            margin-top: 8px;
            height: 55px;
            border-radius: 8px;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: -50%;
                right: -50%;
                bottom: -50%;
                left: -50%;
                border-radius: 8px;
                border: 1px solid #E1E8EF;
                transform: scale(0.5);
                z-index: 2;
                pointer-events: none;
            }
        }

        :deep(.input-box) {
            input::placeholder {
                text-align: center;
            }
        }

        .use-num {
            color: #333;
            font-size: 18px;
            margin-top: 20px;
        }

        .coupon-list {
            border-radius: 8px;
            opacity: 1;
            padding: 0 10px;
            margin-top: 8px;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: -50%;
                right: -50%;
                bottom: -50%;
                left: -50%;
                border-radius: 8px;
                border: 1px solid #E1E8EF;
                transform: scale(0.5);
                z-index: 2;
                pointer-events: none;
            }

            .coupon-item {
                padding: 15px 5px;

                .title {
                    font-size: 20px;
                    font-weight: bold;
                    color: #0082EF;
                }

                .info {
                    font-size: 15px;
                    color: #333333;
                    margin-top: 6px;
                }
            }
        }
    }

    .popup-bottom {
        padding: 15px;
        display: flex;

        /* .van-button {
            flex: 1;
            border-radius: 8px;
            color: #333 !important;

            &+.van-button {
                flex: 2;
                margin-left: 20px;
                color: white !important;
            }
        } */
    }
}
</style>